<template>
  <div class="laboratoryManagement">
    <header>
      <div class="title">管理痛点</div>
      <ManagementPainPoints :list="MANAGE_LIST"></ManagementPainPoints>
    </header>
    <main>
      <div class="title">方案亮点</div>
      <IconLights :list="LIGHTS"></IconLights>
    </main>
    <section>
      <div class="title">方案优势</div>
      <Advantage :list="TECHNICAL_CAPACITY"></Advantage>
      <div class="title" style="margin-top: 56px">业务阶段</div>
      <div class="lc-title">分类申报、暂存转运、合规处置</div>
      <div class="lc">
        <div class="lc-left">
          <OssImg
            src="images/solution/resourceSharing/computer1.png"
            alt=""
          />
        </div>
        <div class="lc-right">
          <div class="lcList">
            <div class="lc-item" v-for="item in LC_LIST" :key="item.key">
              <div class="lc-img" :style="{ backgroundColor: item.color }">
                <OssImg :src="item.imgPath" />
              </div>
              <div style="flex: 1">
                <div class="lc-t">{{ item.text }}</div>
                <div class="lc-desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref,onMounted } from "vue";
import ManagementPainPoints from "./components/ManagementPainPoints.vue";
import IconLights from "./components/IconLights.vue";
import Advantage from "./components/Advantage.vue";
import { WOW } from 'wowjs'
onMounted(()=>{
  const wow = new WOW();
  wow.init();
})
const MANAGE_LIST = ref([
  {
    iconPath: "images/solution/wasteDisposal/icon1.png",
    title: "分类管理混乱",
    desc: "缺乏标准化巡检清单和操作指引，巡检内容、频次、路线随意，易遗漏关键风险点，导致隐患排查不全面",
    key: 0,
  },
  {
    iconPath: "images/solution/wasteDisposal/icon2.png",
    title: "暂存监管缺失",
    desc: "巡检数据多以纸质或分散电子表格存储，难以实现统一分析与整合，无法从海量数据中挖掘潜在风险趋势，难以为管理决策提供支撑",
    key: 1,
  },
  {
    iconPath: "images/solution/wasteDisposal/icon3.png",
    title: "转运追溯困难",
    desc: "没有量化的巡检工作考核标准，难以评估巡检人员工作质量，无法形成有效激励和约束，降低巡检工作积极性和主动性",
    key: 2,
  },
  {
    iconPath: "images/solution/wasteDisposal/icon4.png",
    title: "法规更新滞后",
    desc: "巡检人员专业能力参差不齐，责任心不足，存在敷衍了事、漏检错检现象，纸质记录易伪造、丢失，无法保证巡检真实性",
    key: 3,
  },
]);
const LIGHTS = ref([
  {
    desc: "采用区块链技术搭建电子联单系统，危废产生、运输、处置全流程数据上链存证，信息不可篡改且实时共享",
    imgPath: "images/solution/wasteDisposal/light1.png",
    color: "#efeeff",
    key: 0,
  },
  {
    desc: "整合区域内危废处置机构资源，构建智能调度平台，基于危废种类、数量及处置机构空闲产能，通过算法自动规划最优转运路线与处置方案，降低运输成本",
    imgPath: "images/solution/wasteDisposal/light2.png",
    color: "#fffaee",
    key: 1,
  },
  {
    desc: "利用大数据分析危废历史产生数据、行业趋势，预测危废产生量与成分变化，提前规划处置资源与应急预案",
    imgPath: "images/solution/wasteDisposal/light3.png",
    color: "#eef7ff",
    key: 2,
  },
]);

const TECHNICAL_CAPACITY = ref([
  {
    title: "跨部门协同效率倍增",
    desc: "多端数据互通平台打破信息壁垒，实现危废申报、审批、转运、处置线上一体化办理，部门间协作效率提升 50%",
    imgPath: "images/solution/wasteDisposal/big_icon1.png",
    key: 0,
  },
  {
    title: "人力成本大幅削减",
    desc: "全流程自动化操作替代大量人工录入、核查工作，减少 60% 以上人力投入，同时降低人为操作失误风险",
    imgPath: "images/solution/wasteDisposal/big_icon2.png",
    key: 1,
  },
  {
    title: "环境效益显著",
    desc: "优化处置方案与转运路线，减少危废在途时间与污染风险；通过高效处置，降低危废长期存储对土壤、水源的污染，助力生态环境保护",
    imgPath: "images/solution/wasteDisposal/big_icon3.png",
    key: 2,
  },
  {
    title: "智能感知精准监测",
    desc: "采用高精度气体、温湿度、液位传感器，实时采集危废暂存环境参数，0.1 秒级响应速度，能精准捕捉微小环境变化，异常数据立即触发声光、短信等多渠道报警",
    imgPath: "images/solution/wasteDisposal/big_icon4.png",
    key: 3,
  },
  {
    title: "防爆型存储设备",
    desc: "暂存柜、仓库采用防爆材质与双层隔热设计，内置自动灭火装置和泄压系统，通过 ATEX、IECEx 等国际防爆认证，可抵御高温、碰撞等极端情况，保障危废存储安全",
    imgPath: "images/solution/wasteDisposal/big_icon5.png",
    key: 4,
  },
  {
    title: "自动化称重计量设备",
    desc: "配备高精度电子地磅与动态称重传感器，具备自动去皮、毛重净重计算功能，数据自动上传管理系统，误差率低于 0.05%，确保危废重量数据精准可靠",
    imgPath: "images/solution/wasteDisposal/big_icon6.png",
    key: 5,
  },
]);
const LC_LIST = ref([
  {
    imgPath: "images/solution/wasteDisposal/yw_icon1.png",
    text: "实验室产生阶段",
    desc: "高校各实验室产生危废后，实验人员需通过校园危废管理平台在线申报，填写危废名称、类别、数量等信息。使用便携式检测终端快速测定危废成分，结合智能分拣指南完成初步分类，将危废封装至专用容器并粘贴 RFID 标签",
    color: "#efeeff",
    key: 0,
  },
  {
    imgPath: "images/solution/wasteDisposal/yw_icon2.png",
    text: "校内暂存转运",
    desc: "危废运送至校内标准化暂存仓库，仓库内置防爆存储设备与环境监测传感器，实时监控温湿度、气体浓度等参数，异常情况自动报警并联动应急处置系统",
    color: "#eef7ff",
    key: 1,
  },
  {
    imgPath: "images/solution/wasteDisposal/yw_icon3.png",
    text: "校外合规处置",
    desc: "校内危废暂存按周期按量，管理部门与外部处置公司完成危废转接工作，并形成电子化台账记录形成处置清单",
    color: "#fffaee",
    key: 2,
  },
]);</script>

<style lang="scss" scoped>
.laboratoryManagement {
  $titleSize: 60px;

  font-family: "PingFang SC";
  .title {
    color: rgba(33, 33, 33, 1);
    font-weight: 500;
    font-size: $titleSize;
    text-align: center;
  }
  main {
    margin: 56px 0px;
  }
  section {
    margin-bottom: 56px;
    .lc-title {
      color: #424242;
      text-align: center;
      font-weight: 600;
      font-size: 32px;
      margin: 24px 0px 50px 0px;
    }
    .lc {
      display: flex;
      .lc-left {
      }
      .lc-right {
        margin-left: 32px;
        .lcList {
          display: flex;
          flex-direction: column;
          gap: 24px;
          .lc-item {
            box-sizing: border-box;
            padding: 16px;
            width: 100%;
            height: 150px;
            border-radius: 16px;
            background: #ffffff;
            display: flex;
            align-items: center;
            gap: 16px;
            .lc-img {
              width: 80px;
              border-radius: 80px;
              height: 80px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .lc-t {
              color: #424242;
              font-weight: 500;
              font-size: 16px;
              margin-bottom: 10px;
            }
            .lc-desc {
              color: #888888;
              font-weight: 500;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
